module.exports = __webpack_public_path__ + "static/img/lightbulb-lg-active.4773d3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lightbulb-lg-active.png
// module id = xKBO
// module chunks = 37